import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "struct1";
const idNext = "struct2";

const next = `
global parameters:
  - parameter: hero
    choices:
      - choice: Peter
      - choice: Susan
      - choice: Edmund
      - choice: Lucy
  - parameter: foe
    choices:
      - choice: witch
      - choice: cyclops
      - choice: giant
  - parameter: weapon
    choices:
      - choice: dagger
      - choice: ranged
        choices:
          - choice: bow
          - choice: crossbow
      - choice: melee
        choices:
          - choice: axe
          - choice: mace
          - choice: sword
  - parameter: name
functions:
  - function: simple
    parameters:
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: mountain
          - choice: river
          - choice: lake
`;

const prev = `
global parameters:
  - parameter: hero
    choices:
      - choice: Peter
      - choice: Susan
      - choice: Edmund
      - choice: Lucy
  - parameter: foe
    choices:
      - choice: witch
      - choice: cyclops
      - choice: giant
  - parameter: weapon
    choices:
      - choice: dagger
      - choice: ranged
        choices:
          - choice: bow
          - choice: crossbow
      - choice: melee
        choices:
          - choice: axe
          - choice: mace
          - choice: sword
functions:
  - function: simple
    parameters:
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: mountain
          - choice: river
          - choice: lake
`;

function ManualStructures1({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_globals") &&
        !document.getElementById("add_global_parameter") && (
          <div
            className={`${styles["container"]} ${styles["container-st1a"]} ${styles["overlay"]}`}>
            <div id="tutorial-text-st1a" className={`${styles["container__text"]}`}>
              <p>To show/hide global parameters click on the header.</p>
            </div>

            <Xarrow
              key={`arrow-1-${renderTrigger}`}
              start="tutorial-text-st1a"
              end="header_globals"
              color="#415B32"
              strokeWidth={2}
              path="smooth"
              curveness={0.8}
              headSize={6}
            />
          </div>
        )}

      {document.getElementById("add_global_parameter") && (
        <div className={`${styles["container"]} ${styles["container-st1b"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-st1b"
            className={`${styles["container__text"]} ${styles["container__text"]}`}>
            <p>Click here to add a global parameter</p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-st1b"
            end="add_global_parameter"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-st1"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Structures are a great way to logically group parameters together! To create
              one, simply make a new parameter and add nested parameters inside it - either manually
              or by dragging and dropping. There are no limits on nesting levels, meaning
              any child parameter can be transformed into a structure the exact same way.
            </p>
            <p>
              Let's try it out! Click the <b>ADD GLOBAL PARAMETER</b> button and name it <b>name</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Start fresh!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateStructures1 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resParam, msg: msgParam } = tutorialUtils.validateParameters(root, "root", ["name"]);

    if (!resParam) {
      setMessage(msgParam);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualStructures1;
